import { render, staticRenderFns } from "./Administrativo.vue?vue&type=template&id=8257e578"
import script from "./Administrativo.vue?vue&type=script&lang=js"
export * from "./Administrativo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports